module.exports = __webpack_public_path__ + "public/55823eb0f2053695a2403e204c1e3220.woff2";